/**
 * @license lucide-react v1.59.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.mjs';

const __iconData = {
  name: "corner-down-left",
  size: 24,
  node: [
    ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }],
    ["path", { d: "m9 10-5 5 5 5", key: "1kshq7" }]
  ]
};
__iconData.node;
const CornerDownLeft = createLucideIcon(__iconData);

export { __iconData, CornerDownLeft as default };
//# sourceMappingURL=corner-down-left.mjs.map
